import * as _ from 'lodash';

import IOverlayTypology = ZoneIQCalibration.IOverlayTypology;
import { BaseMutableModel } from '../../common-models/base-mutable-model.model';
import { IOverlayTypologyModel } from 'src/app/interfaces/overlay-typology-model.interface';

export class OverlayTypologyModel extends BaseMutableModel<IOverlayTypology> implements IOverlayTypologyModel {
    Id: number;
    OverlayId: number;
    TypologyId: number;
    IsTypologyEnabledForAllOverlays: boolean;
    IsEnabled: boolean;
    IsAddedToList: boolean;
    IsDefault: boolean;
    hasLinks: boolean;
    hasComments: boolean;
    hasAssumptions: boolean;

    constructor(data) {
        super(data, [
            'OverlayId',
            'TypologyId',
            'IsTypologyEnabledForAllOverlays',
            'IsEnabled',
            'IsAddedToList',
            'IsDefault'
        ]);
        Object.assign(this, _.pick(data));
    }
}
